import { NgModule } from '@angular/core';
import { AutofocusDirective } from './autofocus.directive';
import { ClickToRelativeUrlDirective } from './click-to-relative-url.directive';
import { IfIsBrowserDirective, IfIsServerDirective } from './if-is-directive';
import { RegexFilterDirective } from './regex-filter.directive';

@NgModule({
  declarations: [
    IfIsServerDirective,
    IfIsBrowserDirective,
    ClickToRelativeUrlDirective,
    AutofocusDirective,
    RegexFilterDirective,
  ],
  exports: [
    IfIsServerDirective,
    IfIsBrowserDirective,
    ClickToRelativeUrlDirective,
    AutofocusDirective,
    RegexFilterDirective,
  ],
})
export class DirectivesModule {}
